import { FaCircle } from "react-icons/fa";
import { MdOutlineFlight } from "react-icons/md";
import { useEffect, useState } from "react";
import {
  getFormattedTime,
} from "@/src/helpers/getFormattedTime";
import { FaSuitcaseRolling } from "react-icons/fa6";
import FlightItem from "./search/FlightItem";

export default function OriginDest({ od, fareBreakdowns, countryList }) {
  const [layoverTimes, setLayoverTimes] = useState([]);
  const [terminalChanges, setTerminalChanges] = useState([]);

  const calculateLayoverAndTerminal = () => {
    const times = [];
    const changes = [];

    for (let i = 0; i < od.FlightDetails.length - 1; i++) {
      const currentFlight = od.FlightDetails[i];
      const nextFlight = od.FlightDetails[i + 1];

      const layoverMinutes = getFormattedTime(
        Math.round(
          (new Date(nextFlight.DepartureTime) -
            new Date(currentFlight.ArrivalTime)) /
          (1000 * 60)
        )
      );

      times.push(layoverMinutes);
      // changes.push({
      //   Change:
      //     currentFlight.DepartureAirport.TerminalID !==
      //     nextFlight.DepartureAirport.TerminalID,
      //   TerminalID: nextFlight.DepartureAirport.TerminalID
      // });
    }

    setLayoverTimes(times);
    setTerminalChanges(changes);
  };

  useEffect(() => {
    if (od.FlightDetails.length > 1) {
      calculateLayoverAndTerminal();
    }
  }, []);
  return (
    <>
      <div className="">
        {od.FlightDetails.map((fd, i) => {
          return (
            <div key={"origD" + i}>
              <FlightItem
                fd={fd}
                countryList={countryList}
                type={"departure"}
                isFirstIndex={i == 0}
              />

              <div className="grid grid-cols-10 px:2 lg:px-4 justify-center items-center">
                <div className="col-span-2  py-4 text-right">
                  <h1 className="text">{getFormattedTime(fd.ElapsedTime)}</h1>
                </div>
                <div className="col-span-1 flex flex-col justify-between h-full items-center px-5">
                  {i == 0 ? (
                    <span className="flex-1 w-1 h-full border-l  border-gray-300 ml-1"></span>
                  ) : (
                    <span className="flex-1 w-1 h-full border-l border-dotted border-gray-300 ml-1"></span>
                  )}
                  <span className="text-gray-300">
                    <MdOutlineFlight className="rotate-180 text-2xl" />
                  </span>
                  <span className="flex-1 w-1 h-full border-l  border-gray-300 ml-1"></span>
                </div>
                <div className="col-span-7 flex-1 py-3">
                  <div>
                    <div className="flex items-center gap-2">
                      <img
                        src={fd.Logo}
                        className="w-12 h:12 rounded object-contain"
                      />
                      <div className="flex flex-col items-start justify-start ">
                        <h1>{fd.Name}</h1>
                        <p className="text-sm text-muted-foreground">
                          {fd.FlightNumber}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="w-full flex p-4">
                <div className="flex ">
                  <img
                    src="https://bcassetcdn.com/public/blog/wp-content/uploads/2022/08/25102532/Emirates-Airlines-Logo.png"
                    alt=""
                    className="w-11 h-11 rounded"
                  />
                  <div className="flex flex-col items-start justify-start">
                    <h2 className=" font-normal text-xs  md:text-base">
                      {fd.Name}
                    </h2>
                  </div>
                </div>
              </div> */}

              <FlightItem
                fd={fd}
                countryList={countryList}
                type={"arrival"}
                isLastIndex={od.FlightDetails.slice(-1)[0] == fd ? true : false}
              />

              {od.FlightDetails.length - 1 > i && (
                <div className="grid grid-cols-10 px:2 lg:px-4 justify-center items-center bg-muted">
                  <div className="col-span-2  py-4 text-right">
                    <h1 className="">
                      {layoverTimes &&
                        layoverTimes.length >= i &&
                        layoverTimes[i]}
                    </h1>
                  </div>
                  <div className="col-span-1 flex flex-col justify-between h-full items-center px-5">
                    <span className="flex-1 w-1 h-full border-l border-dotted border-gray-300 ml-1"></span>
                    <span className="text-gray-300">
                      <FaCircle className="w-2 h-2" />
                    </span>
                    <span className="flex-1 w-1 h-full border-l border-dotted border-gray-300 ml-1"></span>
                  </div>
                  <div className="col-span-7 flex-1 py-3">
                    <div>
                      <h3 className="text-base lg:text-lg">Layover</h3>
                    </div>
                  </div>
                </div>
                // <div className="col-span-7 flex-1 py-3">
                //   <div>
                //     <h3 className="text-base lg:text-lg">Layover {layoverTimes}</h3>
                //     <p className="text-sm text-muted-foreground">
                //       Change to terminal {terminalChanges}
                //     </p>
                //   </div>
                // </div>
              )}
            </div>
          );
        })}
      </div>
      {fareBreakdowns && (
        <div className="m-3 p-3 border rounded-lg">
          <h3 className="text-lg font-medium">Baggage Information </h3>
          {fareBreakdowns.map((fare) => {
            return fare.Baggages.map((baggage, i) => {
              return (
                <div
                  className="py-1 flex items-center text-sm"
                  key={baggage.BagType + i}
                >
                  <FaSuitcaseRolling className="me-2" />
                  <span className="me-1">{baggage.BagType}:</span>
                  <span>{baggage.Quantity + " " + baggage.Unit}</span>
                </div>
              );
            });
          })}
        </div>
      )}
    </>
  );
}